import AxiosInterceptor from 'api/interceptor';

const api = new AxiosInterceptor();

export default {
  find(id) {
    return api.get('/time_slots/' + id);
  },
  get() {
      return api.get('/time_slots');
  },
  delete(id) {
    return api.delete('/time_slots/' + id);
  },
  create(input) {
    return api.post('/time_slots', {title: input});
  },
  update(id, input) {
    return api.put('/time_slots/' + id, {title: input});
  },
};